import { Injectable } from '@angular/core';
import { DemoViewerApiService } from './demo-viewer-api.service';
import { NavigationHotspot } from './models/NavigationHotspot';

@Injectable({
  providedIn: 'root',
})
export class WalkthroughService {
  constructor(private apiService: DemoViewerApiService) {}
  private walkthroughs: NavigationHotspot[] = [];

  // Map for quick lookup by current_point_uuid
  private walkthroughLookup: Map<string, NavigationHotspot[]> = new Map();

  public updateWalkthroughs(reportId: string, floorId: string): void {
    this.apiService.getWalkthroughs(reportId, floorId).subscribe((walkthroughs) => {
      this.walkthroughs = walkthroughs.data;
      if (this.walkthroughs.length > 0) this.buildLookupMaps();
    });
  }

  /**
   * Build lookup maps for efficient querying
   */
  private buildLookupMaps(): void {
    this.walkthroughLookup.clear();

    this.walkthroughs.forEach((walkthrough) => {
      if (!this.walkthroughLookup.has(walkthrough.current_point_uuid)) {
        this.walkthroughLookup.set(walkthrough.current_point_uuid, []);
      }
      this.walkthroughLookup.get(walkthrough.current_point_uuid)?.push(walkthrough);
    });
  }

  /**
   * Get walkthrough information by current point UUID
   * @param currentPointUuid The UUID of the current point
   * @returns Array of walkthrough objects for the given point, or empty array if none found
   */
  getWalkthroughs(currentPointUuid: string): NavigationHotspot[] {
    return this.walkthroughLookup.get(currentPointUuid) || [];
  }

  /**
   * Get a specific walkthrough by its ID
   * @param walkthroughId The ID of the walkthrough
   * @returns The walkthrough object, or null if not found
   */
  getWalkthroughById(walkthroughId: string): NavigationHotspot | null {
    return this.walkthroughs.find((w) => w.id === walkthroughId) || null;
  }

  clear(): void {
    this.walkthroughs = [];
    this.walkthroughLookup.clear();
  }
}
